import React, { useState, useEffect } from "react";
import { styled, alpha } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import InputBase from "@mui/material/InputBase";
import Badge from "@mui/material/Badge";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MailIcon from "@mui/icons-material/Mail";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MoreIcon from "@mui/icons-material/MoreVert";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, Button } from "@mui/material";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import { useNavigate } from "react-router-dom";
import Notifications from "./Notifications";
import api from "../../utils/api";
import { logoutUser } from "../../Actions/userActions";
import { Icon } from "@material-ui/core";
import DashboardIcon from "@mui/icons-material/Dashboard";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(10),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

export default function Navbar({
  setSearchedText,
  showSidebar,
  setShowSidebar,
}) {
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const dispatch = useDispatch();
  const [showNotifications, setShowNotifications] = useState(false);
  const [allNotifications, setAllNotifications] = useState([]);
  const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);
  const [notRecCount, setNotRecCount] = useState(0);
  const [userData, setUserdata] = useState({});
  const [refresher, setRefresher] = useState(0);
  // useEffect(() => {
  //   setTimeout(() => {
  //     setRefresher(Math.floor(Math.random() * 10));
  //   }, 2000);
  // }, [refresher]);
  useEffect(() => {
    api
      .get(`/user/getUserdataById/${currentUser?.id}`)
      .then((res) => {
        let { data } = res;
        console.log("jdjsnfvndfnbjnbgonfzdb", data);
        setUserdata({
          status: data?.status,
          gender: data?.gender,
          university: data?.gender,
          phone: data?.phone,
          address: data?.address,
          name: data?.name,
          profile: data?.profile,
        });
      })
      .catch((err) => console.log(err));
  }, [currentUser]);
  const hideNotifications = () => {
    setShowNotifications(false);
  };

  useEffect(() => {
    setNotRecCount(0);

    let count = 0;
    allNotifications.map((r) => {
      if (!r.isReceived) {
        count++;
      }
    });
    setNotRecCount(count);
    // console.log("count", count);
    // console.log("res", allNotifications);
  }, [allNotifications, window.location.pathname]);
  useEffect(() => {
    // console.log("currentuser", currentUser?.id);
    setInterval(() => {
      api
        .get("/notifications")
        .then((res) => {
          console.log("response" > res.data);
          let Array = res.data;
          api
            .get(`/notifications/for-specific-receiver/${currentUser?.id}`)
            .then((re) => {
              // console.log("response 2" > re.data);
              if (re.data.length > 0) {
                re.data.map((r) => Array.push(r));
              }
              setAllNotifications(Array);
            })
            .catch((err) => console.log(err));
        })
        .catch((err) => console.log);
    }, 5000);

    // }, [refresher]);
  }, []);

  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
      sx={{ backgroundColor: "#00000040" }}
    >
      <MenuItem onClick={handleMenuClose}>
        {userData?.profile ? (
          <>
            <Avatar
              src={userData?.profile}
              sx={{ width: "30px", height: "30px", marginRight: "10px" }}
            />
          </>
        ) : (
          <>
            <Avatar sx={{ width: "30px", height: "30px", marginRight: "10px" }}>
              {currentUser?.name?.at(0)?.toUpperCase()}
            </Avatar>
          </>
        )}

        {currentUser?.name}
      </MenuItem>
      <MenuItem
        onClick={() => {
          navigate("/profile");
          handleMenuClose();
        }}
      >
        <Box
          sx={{
            width: "30px",
            height: "30px",
            background: "whitesmoke",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            padding: "3px",
            marginRight: "6px",
          }}
        >
          <ManageAccountsOutlinedIcon />
        </Box>
        My account
      </MenuItem>
      <MenuItem
        onClick={() => {
          navigate("/settings");
          handleMenuClose();
        }}
      >
        <Box
          sx={{
            width: "30px",
            height: "30px",
            background: "whitesmoke",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            padding: "3px",
            marginRight: "6px",
          }}
        >
          <SettingsOutlinedIcon />
        </Box>
        Settings
      </MenuItem>
      <MenuItem
        onClick={() => {
          handleMenuClose();
          dispatch(logoutUser());
        }}
      >
        <Box
          sx={{
            width: "30px",
            height: "30px",
            background: "whitesmoke",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            padding: "3px",
            marginRight: "6px",
          }}
        >
          <LogoutOutlinedIcon />
        </Box>
        Logout
      </MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        {/* <IconButton size="large" aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={4} color="error">
            <MailIcon />
          </Badge>
        </IconButton> */}
        <p>Messages</p>
      </MenuItem>
      <MenuItem
        onClick={() => {
          setShowNotifications(true);
          handleMobileMenuClose();
        }}
      >
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Badge badgeContent={notRecCount} color="error">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          {userData?.profile ? (
            <Avatar
              sx={{ width: "30px", height: "30px", marginRight: "10px" }}
              src={userData?.profile}
            />
          ) : (
            <AccountCircle sx={{ color: "fontPrimaryColor.main" }} />
          )}
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );
  /* foing sfajssssssssss**/
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        sx={{
          backgroundColor: "colorWhite.main",
          padding: {
            xs: "0 2vw",
            lg: "0 5vw",
          },
          borderBottom: "1px solid lightgray",
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 2px 0px",
        }}
      >
        <Toolbar>
          {/* <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton> */}
          <IconButton
            sx={{ display: { xs: "block", sm: "none" } }}
            onClick={() => setShowSidebar(true)}
          >
            <DashboardIcon sx={{ color: "#fff", marginRight: "10px" }} />
          </IconButton>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ display: { xs: "none", sm: "block" }, fontWeight: "800" }}
            color="colorOne.main"
            className="website__logo__title"
          >
            A<span>lumni</span>S<span>ocial</span>C<span>orner</span>
          </Typography>
          {currentUser?.id ? (
            <>
              {" "}
              <Search
                sx={{
                  backgroundColor: "colorWhiteSmoke.main",
                  color: "fontPrimaryColor.main",
                  borderBottom: "1px solid lightgray",
                }}
              >
                {/* <SearchIconWrapper> */}
                <IconButton
                  sx={{ marginLeft: "10px" }}
                  onClick={(e) => navigate("/search")}
                >
                  <SearchIcon sx={{ color: "fontPrimaryColor.main" }} />
                </IconButton>
                {/* </SearchIconWrapper> */}
                <StyledInputBase
                  placeholder="Search…"
                  inputProps={{ "aria-label": "search" }}
                  sx={{ width: "30vw" }}
                  onChange={(e) => setSearchedText(e.target.value)}
                />
              </Search>
              <Box sx={{ flexGrow: 1 }} />
              <Box sx={{ display: { xs: "none", md: "flex" } }}>
                {/* <IconButton
                  size="large"
                  aria-label="show 4 new mails"
                  color="inherit"
                >
                  <Badge badgeContent={4} color="error">
                    <MailIcon />
                  </Badge>
                </IconButton> */}
                <IconButton
                  size="large"
                  aria-label="show 17 new notifications"
                  color="inherit"
                  onClick={() => {
                    setShowNotifications(true);
                    setRefresher(Math.floor(Math.random() * 10));
                  }}
                >
                  <Badge badgeContent={notRecCount} color="error">
                    <NotificationsIcon
                      sx={{ color: "fontPrimaryColor.main" }}
                    />
                  </Badge>
                </IconButton>
                <IconButton
                  size="large"
                  edge="end"
                  aria-label="account of current user"
                  aria-controls={menuId}
                  aria-haspopup="true"
                  onClick={handleProfileMenuOpen}
                  color="inherit"
                >
                  <AccountCircle sx={{ color: "fontPrimaryColor.main" }} />
                </IconButton>
              </Box>
              <Box sx={{ display: { xs: "flex", md: "none" } }}>
                <IconButton
                  size="large"
                  aria-label="show more"
                  aria-controls={mobileMenuId}
                  aria-haspopup="true"
                  onClick={handleMobileMenuOpen}
                  color="inherit"
                >
                  <MoreIcon />
                </IconButton>
              </Box>
            </>
          ) : (
            <Button
              className=" ml-3"
              onClick={() => navigate("/login")}
              sx={{
                color: "#fff",
                backgroundColor: "colorThree.main",
                height: "30px",
                marginLeft: "auto",
                marginTop: "3px",
              }}
            >
              Login
            </Button>
          )}
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
      {showNotifications ? (
        <Notifications
          hideNotifications={hideNotifications}
          setUnreadNotificationCount={setUnreadNotificationCount}
          notifications={allNotifications}
        />
      ) : (
        <></>
      )}
    </Box>
  );
}
